import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";

function HeaderEdit() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [form, setForm] = useState({
        title: "",
        focus_position: "center",
        active: 1,
        image_url: "",
    });
    const [imageFile, setImageFile] = useState(null);

    // load data awal
    useEffect(() => {
        const fetchHeader = async () => {
            try {
                const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/header/${id}`);
                setForm({
                    title: data.title || "",
                    focus_position: data.focus_position || "center",
                    active: data.active ?? 1,
                    image_url: data.image_url || "",
                });
            } catch (e) {
                console.error(e);
                Swal.fire("Gagal", "Tidak dapat memuat data header.", "error");
            }
        };
        fetchHeader();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleFile = (e) => {
        setImageFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = new FormData();
            data.append("title", form.title);
            data.append("focus_position", form.focus_position);
            data.append("active", form.active);
            if (imageFile) data.append("image", imageFile);

            await axios.put(`${process.env.REACT_APP_API_URL}/header/${id}`, data, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            Swal.fire({
                icon: "success",
                title: "Berhasil disimpan!",
                timer: 1200,
                showConfirmButton: false,
            });
            navigate("/header"); // kembali ke list
        } catch (err) {
            console.error(err);
            Swal.fire("Gagal", "Tidak dapat menyimpan perubahan.", "error");
        }
    };

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <h1>Edit Header</h1>
                        <small className="text-muted">Ubah data header halaman tertentu.</small>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-header bg-primary text-white">
                                <h3 className="card-title mb-0">Form Edit Header</h3>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group mb-3">
                                        <label>Judul</label>
                                        <input
                                            type="text"
                                            name="title"
                                            className="form-control"
                                            value={form.title}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group mb-3">
                                        <label>Posisi Fokus</label>
                                        <select
                                            name="focus_position"
                                            className="form-control"
                                            value={form.focus_position}
                                            onChange={handleChange}
                                        >
                                            <option value="top">Atas</option>
                                            <option value="center">Tengah</option>
                                            <option value="bottom">Bawah</option>
                                        </select>
                                    </div>

                                    <div className="form-group mb-3">
                                        <label>Gambar</label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            className="form-control"
                                            onChange={handleFile}
                                        />
                                        {form.image_url && (
                                            <div
                                                style={{
                                                    marginTop: "10px",
                                                    width: "100%",
                                                    maxWidth: "500px",
                                                    height: "200px",
                                                    borderRadius: "8px",
                                                    background: `url('${form.image_url}') center / cover no-repeat`,
                                                    border: "1px solid #e5e7eb",
                                                }}
                                            ></div>
                                        )}
                                    </div>

                                    <button type="submit" className="btn btn-primary">
                                        Simpan
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary ml-2"
                                        onClick={() => navigate("/header")}
                                    >
                                        Batal
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default HeaderEdit;
